import { CircleSmall } from 'lucide-react';
import { Badge } from './badge';

export type DealPreorderBadgeProps = {
  is_pre_order: boolean;
};

export const DealPreorderBadge = ({ is_pre_order }: DealPreorderBadgeProps) => {
  if (!is_pre_order) {
    return null;
  }

  return (
    <Badge className="text-black bg-white  text-xs shadow-none rounded-full border-foreground/10 pointer-events-none pl-1 pr-2 whitespace-nowrap">
      <CircleSmall
        fill="var(--color-indigo-400)"
        stroke="var(--color-indigo-400)"
        className="size-4 mr-1"
      />
      Pre-order
    </Badge>
  );
};
